import type { MoxxCarlineGroup } from '../../@types/MoxxTypes';

export function getCarlineIdsWithoutDiscoverLinks(carlineGroups: MoxxCarlineGroup[]): string[] {
  return carlineGroups
    .flatMap(({ carlines }) => carlines)
    .filter(({ discoverLinkUrl }) => discoverLinkUrl === undefined)
    .map(({ id }) => id);
}
